export default __webpack_public_path__ + "static/media/King.378e9412.jpg";